// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const Metabolein = {
  productCode: "SBOVZ-Metabolein",
  productName: "Metabolein (GLP-1)",
  ingredients: "Trigonella foenum-graecum, Allium sativum, Mushrooms",
  overview:" Metabolein is a blend of Fenugreek seed protein complex, AlliciB6 (Garlic vitamer complex) and Shiitake Vitamer Complex, standardized for natural vitamins and minerals for helping blood sugar metabolism and its balance",
  assay:"Fenugreek seed protein 10 %; Allicin: 0.5 % Natural Thiamine: 2.5 mg: Natural Niacin: 5 mg; Natural Pyridoxine: 4 mg; B12-Corrinoids: 10 mcg; Natural Zinc: 2 mg",
  coNutrients:" Secondary metabolites include amino acids, alkaloids, Saponins and flavonoids.",
  studies:"",
  benefits:"Metabolein is a certified organic dietary fibre ingredient that brings together a judicious blend of fenugreek and garlic fibre proven to improve the gut microbiome function. Offers a balance of saccharides to help improve metabolic health. Metabolein supplementation modulates HDL Balance and Total Cholesterol. Helps enhancement of epithelial barrier function which prevents the translocation of pathogens from intestine into the blood. Helps regulate systemic signalling and immunomodulation. ",
  functionalUse: {
    main: "💊︎ Capsule",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForRegenerativeHealth/Metabolein-1.png",
    "images/Portfolio/OrgavitazForRegenerativeHealth/Metabolein-2.png",
    "images/Portfolio/OrgavitazForRegenerativeHealth/Metabolein-3.png",
    "images/Portfolio/OrgavitazForRegenerativeHealth/Metabolein-4.png",
    "images/Portfolio/OrgavitazForConditions/Garlic-2.png"

    

  ],
  certificates: [
   "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default Metabolein;
